import { Button, Modal, Switch, Select, Table, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import {
  dashboardGraphApi,
  ProjectMemberApi,
  TodoDashboardApi,
} from "../../../api";
import { fetchToDoList } from "../../../api/dashboard.api";
import { fetchOrganisationBranches } from "../../../api/organisation.api";
import { fetchProjects } from "../../../api/project.api";
import { LogEvents, LoggerContext } from "../../../context/logging";
import {
  getFormattedDate,
  getYYYYMMDDFormattedDate,
  getYYYYMMDDFormattedDateWithAddedDays,
} from "../../../utils/DateFunctions/dateFormatter";
import { numberWithCommas } from "../../../_helper/Misc/number";
import BasicColumnChart from "../../AntdCharts/BasicColumnChart";
import GroupedColumnPlot from "../../AntdCharts/GroupedColumnPlot";
import KnobComponent from "../../Charts/KnobChart/KnobComponent";
import { Loader } from "../../Loader";
import CardHeaderComponent from "../Common/CardHeader";
import AddMember from "./AddMember";
import "./index.css";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const Dashboard = (props) => {
  const logger = React.useContext(LoggerContext);

  const columns = [
    {
      title: "Item name",
      key: "boq_item",
      ellipsis: true,
      dataIndex: "boq_item",
      width: 150,
    },
    {
      title: "Status",
      key: "po_status",
      render: (data) => (
        <span>
          {data?.po_status ? (
            <Tag color="blue">Raised</Tag>
          ) : (
            <Tag color="warning">Pending</Tag>
          )}
        </span>
      ),
      width: 150,
    },
    {
      title: "Deadline",
      key: "timeline",
      render: (data) => <span>{getFormattedDate(data?.timeline)}</span>,
      width: 150,
    },
  ];

  const [data, setData] = useState();
  const [todoData, setTodoData] = useState([]);
  const history = useNavigate();
  const [graph_3_data, setGraph3Data] = useState([]);
  const [graph_4_data, setGraph4Data] = useState([]);
  const [graph_5_data, setGraph5Data] = useState([]);
  const [graph_1_with_tax, setGraph1WithTax] = useState(true);
  const [noBudgetItemsCardVisible, setNoBudgetItemsCardVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [projectMembers, setProjectMembers] = useState([]);
  const [todoDataParams, setTodoDataParams] = useState(null);
  const [noMembersInProjectCardlVisible, setNoMembersInProjectCardVisible] =
    useState(false);
  const [noMembersInProjectModalVisible, setNoMembersInProjectModalVisible] =
    useState(false);
  const [noBudgetItemsModalVisible, setNoBudgetItemsModalVisible] =
    useState(false);
  const { project_id } = useParams();

  const getData = async () => {
    if (project_id) {
      setLoading(true);
      await axios
        .get(dashboardGraphApi + "?project=" + project_id)
        .then((res) => {
          setData(res?.data);
          formatForGraphs({ graphData: res?.data });
          console.log("result", res);
        })
        .catch((e) => {
          setNoBudgetItemsModalVisible(true);
        })
        .finally(() => {
          setLoading(false);
        });

      axios.get(`${ProjectMemberApi}?project=${project_id}`).then((res) => {
        if (res?.data?.length < 2) {
          setNoMembersInProjectModalVisible(true);
        }
      });
    } else {
      setLoading(true);
      await axios
        .get(dashboardGraphApi + "?project=" + props?.settings?.project.id)
        .then((res) => {
          setData(res?.data);
          formatForGraphs({ graphData: res?.data });
          console.log("result", res);
        })
        .catch((e) => {
          setNoBudgetItemsCardVisible(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const getTodoData = (params) => {
    fetchToDoList({ params: { ...params } }).then((res) => {
      setTodoData(res);
    });
  };

  useEffect(() => {
    getData();
    fetchMembers({ project: project_id ?? props.settings.project.id });

    logger.log(LogEvents.projectDashboard, {});
  }, []);

  const fetchMembers = (params = {}) => {
    axios.get(`${ProjectMemberApi}`, { params: { ...params } }).then((res) => {
      let memberCurrent = "";
      const arr = res?.data?.map((member) => {
        if (member?.user_organisation?.user?.id == props.settings?.user?.id) {
          memberCurrent = member.id;
        }
        return {
          ...member,
          value: member.id,
          label: member?.user_organisation?.user?.name,
        };
      });
      setProjectMembers([
        {
          value: null,
          label: "All",
        },
        ...arr,
      ]);
      setTodoDataParams({
        status: "all",
        project_id: project_id ?? props.settings.project.id,
        timeline__gte: getYYYYMMDDFormattedDate(moment()),
        timeline__lte: getYYYYMMDDFormattedDate(moment()),
        project_member: memberCurrent,
        timeline: "day",
      });
      getTodoData({
        status: "all",
        project_id: project_id ?? props.settings.project.id,
        timeline__gte: getYYYYMMDDFormattedDate(moment()),
        timeline__lte: getYYYYMMDDFormattedDate(moment()),
        project_member: memberCurrent,
      });
    });
  };

  const formatForGraphs = ({ graphData }) => {
    let dataFromApiForGraph3 = graphData?.graph_3;
    let dataFromApiForGraph4 = graphData?.graph_4;
    let dataFromApiForGraph5 = graphData?.graph_5;
    let graph_3 = [];
    let graph_4 = [];
    let graph_5 = [];

    dataFromApiForGraph3?.map((category) => {
      graph_3.push({
        name: "Budget",
        category: category?.category_name,
        value: category?.budget,
      });
      graph_3.push({
        name: "Actual",
        category: category?.category_name,
        value: category?.actual,
      });
    });
    // console.log(graph_3);
    setGraph3Data(graph_3);

    dataFromApiForGraph4?.map((category) => {
      graph_4.push({
        name: "Pending",
        category: category?.category_name,
        value: category?.pending,
      });
      graph_4.push({
        name: "Raised",
        category: category?.category_name,
        value: category?.raised,
      });
    });
    // console.log(graph_3);
    setGraph4Data(graph_4);

    dataFromApiForGraph5?.map((category) => {
      graph_5.push({
        name: "Sales Price",
        category: category?.category_name,
        value: category?.boq_price,
      });
      graph_5.push({
        name: "Target Price",
        category: category?.category_name,
        value: category?.budget_price,
      });
      graph_5.push({
        name: "PO Price",
        category: category?.category_name,
        value: category?.po_price,
      });
    });
    // console.log(graph_3);
    setGraph5Data(graph_5);
  };
  useEffect(() => {
    if (data?.graph_1?.budget == 0 && !noMembersInProjectModalVisible) {
      setNoBudgetItemsCardVisible(true);
    }
    if (project_id) {
      axios.get(`${ProjectMemberApi}?project=${project_id}`).then((res) => {
        if (res?.data?.length < 2) {
          setNoMembersInProjectModalVisible(true);
        }
      });
    } else {
      axios.get(`${ProjectMemberApi}?project=${project_id}`).then((res) => {
        if (res?.data?.length < 2) {
          setNoMembersInProjectModalVisible(true);
        }
      });
    }
  }, [data]);

  return (
    <Container fluid={true} className="dashboard-default-sec">
      {/* <Col xl="12" className="box-col-12 des-xl-100">
        <Row>
          <Col xl="6" md="6">
            <ProfileGreeting />
          </Col>
        </Row>
      </Col> */}
      {noBudgetItemsCardVisible && (
        <Col>
          <Card className="setup-required px-2">
            <Row className="p-2">
              <div className="col-9 py-1">
                Currently there are no items in your project to create PO/WOs
                please add budget items.
              </div>
              <div className="col-3 d-flex justify-content-end">
                <Button
                  onClick={() => {
                    history(`/app/project/budget`);
                  }}
                  className="setup-required-btn"
                >
                  Go to Budget Section
                </Button>
              </div>
            </Row>
          </Card>
        </Col>
      )}

      {/* {noMembersInProjectCardlVisible && (
        <Col>
          <Card className="setup-required px-2">
            <Row className="p-2">
              <div className="col-9 py-1">
                Currently there are no members in your project to add members go
                to project settings.
              </div>
              <div className="col-3 d-flex justify-content-end">
                <Button
                  onClick={() => {
                    history(`/app/project/project-settings?tab=2`);
                  }}
                  className="setup-required-btn"
                >
                  Add Members
                </Button>
              </div>
            </Row>
          </Card>
        </Col>
      )} */}
      <Row>
        <Col xl="6" xxl="6" lg="12" md="12" sm="12">
          <Card>
            <CardHeader>
              <Row>
                <Col xl="6" xxl="6" md="12" sm="12" lg="6">
                  <CardHeaderComponent
                    title="Budget vs Actual Summary"
                    subtitle=""
                  />
                </Col>
                <Col xl="6" xxl="6" md="12" sm="12" lg="6">
                  <Switch
                    checked={graph_1_with_tax}
                    onChange={(e) => {
                      setGraph1WithTax(e);
                      logger.log(LogEvents.budgetAndActualGraphWithTax, {});
                    }}
                  />
                  {graph_1_with_tax ? " With tax" : " Without tax"}
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {loading ? (
                <Loader />
              ) : (
                <Row>
                  <Col xl="6" xxl="6" md="12" sm="12" lg="6">
                    <KnobComponent
                      raised={
                        graph_1_with_tax
                          ? data?.graph_1?.utilized_budget_percentage?.toFixed(
                              2
                            ) ?? 0
                          : data?.graph_1?.without_tax_utilized_budget_percentage?.toFixed(
                              2
                            ) ?? 0
                      }
                      pending={
                        graph_1_with_tax
                          ? data?.graph_1?.utilized_budget_percentage?.toFixed(
                              2
                            ) ?? 0 < 100
                            ? 100 -
                              data?.graph_1?.utilized_budget_percentage?.toFixed(
                                2
                              )
                            : 0
                          : data?.graph_1?.without_tax_utilized_budget_percentage?.toFixed(
                              2
                            ) ?? 0 < 100
                          ? 100 -
                            data?.graph_1?.without_tax_utilized_budget_percentage?.toFixed(
                              2
                            )
                          : 0
                      }
                    />
                  </Col>
                  <Col xl="6" xxl="6" md="12" sm="12" lg="6" className="h-100">
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="7"
                        xxl="7"
                        md="7"
                        sm="7"
                        lg="7"
                        className="fw-bold"
                      >
                        Budget
                      </Col>
                      <Col xl="5" xxl="5" md="5" sm="5" lg="5">
                        {graph_1_with_tax ? (
                          <>{numberWithCommas(data?.graph_1?.budget?.toFixed(2)) ?? 0}</>
                        ) : (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.without_tax_budget?.toFixed(2)
                            ) ?? 0}
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="7"
                        xxl="7"
                        md="7"
                        sm="7"
                        lg="7"
                        className="fw-bold"
                      >
                        Total PO raised
                      </Col>
                      <Col xl="5" xxl="5" md="5" sm="5" lg="5">
                        {graph_1_with_tax ? (
                          <>
                            {numberWithCommas(data?.graph_1?.total_po_raised?.toFixed(2)) ??
                              0}
                          </>
                        ) : (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.without_tax_total_po_raised?.toFixed(2)
                            ) ?? 0}
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="7"
                        xxl="7"
                        md="7"
                        sm="7"
                        lg="7"
                        className="fw-bold"
                      >
                        Available Budget
                      </Col>
                      <Col xl="5" xxl="5" md="5" sm="5" lg="5">
                        {graph_1_with_tax ? (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.difference_in_budget?.toFixed(2)
                            ) ?? 0}
                          </>
                        ) : (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.without_tax_difference_in_budget?.toFixed(2)
                            ) ?? 0}
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="7"
                        xxl="7"
                        md="7"
                        sm="7"
                        lg="7"
                        className="fw-bold"
                      >
                        Forecasted Cost
                      </Col>
                      <Col xl="5" xxl="5" md="5" sm="5" lg="5">
                        {graph_1_with_tax ? (
                          <>
                            {numberWithCommas(data?.graph_1?.forecasted_cost?.toFixed(2)) ??
                              0}
                          </>
                        ) : (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.without_tax_forecasted_cost?.toFixed(2)
                            ) ?? 0}
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="7"
                        xxl="7"
                        md="7"
                        sm="7"
                        lg="7"
                        className="fw-bold"
                      >
                        Absolute Margin
                      </Col>
                      <Col xl="5" xxl="5" md="5" sm="5" lg="5">
                        {graph_1_with_tax ? (
                          <>
                            {numberWithCommas(data?.graph_1?.absolute_margin?.toFixed(2)) ??
                              0}
                          </>
                        ) : (
                          <>
                            {numberWithCommas(
                              data?.graph_1?.without_tax_absolute_margin?.toFixed(2)
                            ) ?? 0}
                          </>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
        <Col xl="6" xxl="6" lg="12" md="12" sm="12">
          <Card>
            <CardHeader>
              <CardHeaderComponent
                title="PO/WO Amount Raised - Budget"
                subtitle=""
              />
            </CardHeader>
            <CardBody>
              {loading ? (
                <Loader />
              ) : (
                <Row>
                  <Col xl="6" xxl="6" md="12" sm="12" lg="6">
                    <BasicColumnChart
                      raised_pending_amount={
                        data?.graph_2?.raised_pending_amount ?? 0
                      }
                      label_color="#212121"
                    />
                  </Col>
                  <Col xl="6" xxl="6" md="12" sm="12" lg="6" className="h-100">
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="8"
                        xxl="8"
                        md="8"
                        sm="8"
                        lg="8"
                        className="fw-bold"
                      >
                        Categories in Project
                      </Col>
                      <Col xl="4" xxl="4" md="4" sm="4" lg="4">
                        {data?.graph_2?.categories ?? 0}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="8"
                        xxl="8"
                        md="8"
                        sm="8"
                        lg="8"
                        className="fw-bold"
                      >
                        POs Raised
                      </Col>
                      <Col xl="4" xxl="4" md="4" sm="4" lg="4">
                        {numberWithCommas(data?.graph_2?.pos_raised?.toFixed(2)) ?? 0}
                      </Col>
                    </Row>
                    <Row style={{ padding: "1rem 0rem" }}>
                      <Col
                        xl="8"
                        xxl="8"
                        md="8"
                        sm="8"
                        lg="8"
                        className="fw-bold"
                      >
                        Vendors Used:
                      </Col>
                      <Col xl="4" xxl="4" md="4" sm="4" lg="4">
                        {numberWithCommas(data?.graph_2?.vendor_used?.toFixed(2)) ?? 0}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
        {/* <Col xl="12" md="6">
            <Card>
              <CardBody>
                <div id="">
                  <Chart
                    options={apexBarChart.options}
                    series={apexBarChart.series}
                    type="bar"
                    height={350}
                  />
                </div>
              </CardBody>
            </Card>
          </Col> */}
      </Row>
      <Col>
        <Col xl="12">
          <Card>
            <CardHeader>
              <CardHeaderComponent
                title="Category Wise - Budget vs Actual (For raised POs)"
                subtitle=""
              />
            </CardHeader>

            <CardBody>
              {loading ? <Loader /> : <GroupedColumnPlot data={graph_3_data} />}
            </CardBody>
          </Card>
        </Col>
      </Col>
      <Col>
        <Col xl="12">
          <Card>
            <CardHeader>
              <CardHeaderComponent
                title="Category Wise - PO/WO Raised vs Pending"
                subtitle=""
              />
            </CardHeader>

            <CardBody>
              {loading ? <Loader /> : <GroupedColumnPlot data={graph_4_data} />}
            </CardBody>
          </Card>
        </Col>
      </Col>

      <Col>
        <Col xl="12">
          <Card>
            <CardHeader>
              <CardHeaderComponent
                title="Sales Price - Target Price - PO Price"
                subtitle=""
              />
            </CardHeader>

            <CardBody>
              {loading ? <Loader /> : <GroupedColumnPlot data={graph_5_data} />}
            </CardBody>
          </Card>
        </Col>
      </Col>

      <Row>
        <Col xl="6" xxl="6" lg="12" md="12" sm="12">
          <Card>
            <CardHeader>
              <CardHeaderComponent title="To do list" subtitle="" />
            </CardHeader>
            <CardBody>
              {loading ? (
                <Loader />
              ) : (
                <React.Fragment>
                  <Row>
                    <Col>
                      <Row className="justify-content-space-between">
                        <Col xl="4">
                          <h6>Member</h6>
                          <Select
                            style={{
                              width: 150,
                            }}
                            value={todoDataParams?.project_member}
                            onChange={(e) => {
                              getTodoData({
                                ...todoDataParams,
                                project_member: e,
                              });

                              setTodoDataParams({
                                ...todoDataParams,
                                project_member: e,
                              });
                            }}
                            options={projectMembers}
                          />
                        </Col>
                        <Col xl="4">
                          <h6>Po status</h6>
                          <Select
                            style={{
                              width: 150,
                            }}
                            value={todoDataParams?.status}
                            onChange={(e) => {
                              getTodoData({
                                ...todoDataParams,
                                status: e,
                              });

                              setTodoDataParams({
                                ...todoDataParams,
                                status: e,
                              });
                            }}
                            options={[
                              {
                                value: "all",
                                label: "All",
                              },
                              {
                                value: false,
                                label: "Pending",
                              },
                              {
                                value: true,
                                label: "Raised",
                              },
                            ]}
                          />
                        </Col>
                        <Col xl="4">
                          <h6>Deadline</h6>
                          <Select
                            style={{
                              width: 150,
                            }}
                            value={todoDataParams?.timeline}
                            onChange={(e) => {
                              const startDate = getYYYYMMDDFormattedDate(
                                moment()
                              );
                              let endDate = startDate;
                              if (e == "day") {
                                endDate = startDate;
                              } else if (e == "week") {
                                endDate = getYYYYMMDDFormattedDateWithAddedDays(
                                  moment(),
                                  7
                                );
                              } else if (e == "month") {
                                endDate = getYYYYMMDDFormattedDateWithAddedDays(
                                  moment(),
                                  30
                                );
                              } else if (e == "all") {
                                endDate = getYYYYMMDDFormattedDateWithAddedDays(
                                  moment(),
                                  1000
                                );
                              }

                              getTodoData({
                                ...todoDataParams,
                                timeline__gte: startDate,
                                timeline__lte: endDate,
                              });
                              setTodoDataParams({
                                ...todoDataParams,
                                timeline__gte: startDate,
                                timeline__lte: endDate,
                                timeline: e,
                              });
                            }}
                            options={[
                              {
                                value: "day",
                                label: "Today",
                              },
                              {
                                value: "week",
                                label: "This week",
                              },
                              {
                                value: "month",
                                label: "This month",
                              },
                              {
                                value: "all",
                                label: "All",
                              },
                            ]}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "1rem" }}>
                    <Table
                        dataSource={todoData}
                        columns={columns}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                      />
                  </Row>
                </React.Fragment>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal
        title="No items in your project."
        centered
        visible={noBudgetItemsModalVisible}
        footer={null}
        onCancel={() => setNoBudgetItemsModalVisible(false)}
        width={"40%"}
        className="no-budget-item-modal-style"
      >
        <Col className="p-2 px-4 text-center">
          <Col className="px-5 text-center">
            Currently there are no items in your project to create PO/WOs please
            add budget items.
          </Col>
          <Button
            onClick={() => {
              history(`/app/project/budget`);
            }}
            className="mt-2"
            type="primary"
          >
            Go to Budget Section
          </Button>
        </Col>
      </Modal>

      <Modal
        title="No members in your project."
        centered
        visible={noMembersInProjectModalVisible}
        footer={null}
        onCancel={() => setNoMembersInProjectModalVisible(false)}
        // width={"30%"}
        className="no-budget-item-modal-style"
      >
        <AddMember onClose={() => setNoMembersInProjectModalVisible(false)} />
      </Modal>
    </Container>
  );
};

export default connect(mapStateToProps)(Dashboard);
